export default function formatSlug(text: string): string | undefined {
  var formattedText = text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(",", "")
    .toLowerCase()
    .trim();

  return formattedText;
}
